import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { ProjectionFields } from '../../repository/types'
import GraphQLJSON from 'graphql-type-json'
import { Product } from '../Product'
import type { IAction } from '../../action/IAction'

@InputType()
export class GetProductsWithBillingMaterialsArgs extends ActionArgs {
  @Field(() => ID)
  productId: string

  @Field(() => [Product])
  products?: Product[]

  @Field(() => GraphQLJSON)
  projection?: ProjectionFields<Product>

  @Field(() => Boolean)
  requiredOnly?: boolean
}

export interface IGetProductsWithBillingMaterials extends IAction<Product, GetProductsWithBillingMaterialsArgs> {}
